import React from "react";
import lazyPage from "../../../../common/helpers/lazyPage";
import Loader from "../../../components/Loader";

export default lazyPage(
    "src/front/pages/plan/ScoresTab/ScoresTab.tsx",
    () => import("./ScoresTab"),
    <Loader margin="auto" />,
);
